export const DEFAULT_TITLE = "Never run out of the products you love";
export const DEFAULT_BODY = `Make things easy with personalized replenishment reminders and
          seamless reordering. We’ll follow up via text - you tell us if you’re
          ready for more (or not).`;
